import { useEffect, useRef, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { Product } from "../interfaces/IProduct";

interface Return {
    products: Product[];
    refs: React.MutableRefObject<Record<number, HTMLDivElement | null>>;
    highlighted: number | null;
    lastAdded: React.MutableRefObject<number | null>;
    add(p: Product): void;
    del(id: number): void;
    inc(id: number): void;
    dec(id: number): void;
    clearAll(): void;
}

export function useProducts(): Return {
    const [products, setProducts] = useState<Product[]>(() => {
        const stored = localStorage.getItem("products");
        return stored ? JSON.parse(stored) : [];
    });

    const refs = useRef<Record<number, HTMLDivElement | null>>({});
    const [highlighted, setHighlighted] = useState<number | null>(null);
    const lastAdded = useRef<number | null>(null);

    const flash = (id: number) => {
        setHighlighted(id);
        setTimeout(() => setHighlighted(null), 1500);
        setTimeout(() => {
            refs.current[id]?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
    };

    const clearAll = () => setProducts([]);

    const add = (p: Product) => {
        setProducts(prev => {
            if (prev.some(x => x.id === p.id)) {
                toast.info("Товар уже добавлен", { theme: "dark" });
                flash(p.id);
                return prev;
            }
            toast.success("Успешно отсканировано");
            const updated = [...prev, { ...p, amount: 1 }];
            setTimeout(() => flash(p.id), 0);

            return updated;
        });
    };


    const del = (id: number) => {
        setProducts(prev => prev.filter(x => x.id !== id));
        toast.success("Успешно удален товар", {
            autoClose: 2000,
            theme: "dark",
            transition: Bounce,
        });
    };

    const inc = (id: number) =>
        setProducts(prev =>
            prev.map(p => (p.id === id ? { ...p, amount: p.amount + 1 } : p))
        );

    const dec = (id: number) =>
        setProducts(prev =>
            prev.map(p =>
                p.id === id && p.amount > 1 ? { ...p, amount: p.amount - 1 } : p
            )
        );

    useEffect(() => {
        localStorage.setItem("products", JSON.stringify(products));
    }, [products]);

    return { products, refs, highlighted, lastAdded, add, del, inc, dec, clearAll };
}
